module.exports = __webpack_public_path__ + "site/img/index4-newyear.ca2e93af.png";